/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';
import { SortableArrayField, ContentModuleModal, ColorField, TextField } from '@molecules';

import Form from '../Form';

import AddImageForm from './AddImageForm';
import { FORM_FIELD, INITIAL_VALUES, MAX_IMAGES } from './constants';
import Item from './Item';
import ListItem from './ListItem';

const LargeImageGallery = ({
  visible,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues = INITIAL_VALUES,
  errors,
}) => {
  const [form] = Form.useForm();

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      form.resetFields();
      hide();
    },
    [form, hide, onSubmit],
  );

  const handleCancel = React.useCallback(() => {
    form.resetFields();
    hide();
  }, [hide, form]);

  const handleAdd = React.useCallback(
    (image) => {
      form.setFields([
        {
          name: FORM_FIELD.IMAGES.name,
          value: [image, ...(form.getFieldValue(FORM_FIELD.IMAGES.name) || [])],
        },
      ]);
    },
    [form],
  );

  return (
    <ContentModuleModal
      visible={visible}
      title="Large image gallery"
      subtitle="Upload up to 30 images."
      okText={onDelete ? 'SAVE CHANGES' : 'ADD LARGE IMAGE GALLERY'}
      onCancel={handleCancel}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onSerializedFinish={handleFinish}
      >
        <Form.WithFieldValue name={FORM_FIELD.IMAGES.name}>
          {(value) => <AddImageForm onFinish={handleAdd} disabled={value?.length >= MAX_IMAGES} />}
        </Form.WithFieldValue>
        <SortableArrayField {...FORM_FIELD.IMAGES} form={form} withPlaceholder withCount>
          {(item) => <ListItem item={item} />}
        </SortableArrayField>
        <ColorField {...FORM_FIELD.BACKGROUND_COLOR} />
        <ColorField {...FORM_FIELD.TEXT_COLOR} />
        <TextField {...FORM_FIELD.TITLE} style={NO_MARGIN_BOTTOM} />
      </Form>
    </ContentModuleModal>
  );
};

LargeImageGallery.Item = Item;

export default LargeImageGallery;
